"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _vuex = require("vuex");
var _yunying = require("@/api/yunying");
var _moduleSidebar = _interopRequireDefault(require("./components/module-sidebar"));
var _modulePage = _interopRequireDefault(require("./components/module-page"));
var _moduleConfig = _interopRequireDefault(require("./components/module-config"));
var _tips = _interopRequireDefault(require("./components/tips"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ModuleSidebar: _moduleSidebar.default,
    ModulePage: _modulePage.default,
    ModuleConfig: _moduleConfig.default,
    Tips: _tips.default
  },
  data: function data() {
    return {
      loading: false,
      loadingText: '...',
      switchFlag: _jsCookie.default.get('url_switch') || 'off',
      // on开 off关
      page_id: this.$route.query.page_id,
      type: this.$route.query.type,
      // 区分应用('')还是模板（public）
      flag: this.$route.query.flag,
      // 页面标识
      isNewWindow: this.$route.query.new_window === 'yes'
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapState)({
    cur_select_module: function cur_select_module(state) {
      return state.components.cur_select_module;
    },
    page_init_data: function page_init_data(state) {
      return state.components.page_init_data;
    },
    current_public_page_id: function current_public_page_id(state) {
      return state.components.current_public_page_id;
    }
  })),
  mounted: function mounted() {
    this.initConfigData();
  },
  methods: {
    // 显示公共配置入口
    showPublicEntry: function showPublicEntry() {
      var flag = this.$route.query.flag;
      var flagArray = ['index', 'result', 'pay', 'result_fans']; // 有公共配置的页面标识
      return flagArray.some(function (v) {
        return flag === v;
      });
    },
    // 跳转公共配置页
    toPublicConfig: function toPublicConfig(flag) {
      // 先暂时这么处理，待优化
      var idObj = {
        index: 1,
        result: 2,
        pay: 3
      };
      var template_id = this.$route.query.template_id;
      var pageId = idObj[flag];
      if (flag === 'result_fans' && this.current_public_page_id) {
        pageId = this.current_public_page_id;
      }
      var url = "/config?page_id=".concat(pageId, "&type=public&flag=").concat(flag, "&template_id=").concat(template_id, "&new_window=yes");
      window.open(url, '_blank');
    },
    // 获取页面配置数据
    initConfigData: function initConfigData() {
      var page_id = this.page_id,
        type = this.type,
        flag = this.flag;
      var template_id = this.$route.query.template_id;
      if (type === 'public') {
        this.$store.dispatch('components/getDefaultPageConfig', {
          flag: flag,
          template_id: template_id
        });
      } else if (type !== 'public' && this.showPublicEntry()) {
        // 应用页面需要公共模板数据做匹配
        this.$store.dispatch('components/getDefaultPageConfig', {
          flag: flag,
          type: 'h5app',
          template_id: template_id
        });
        this.$store.dispatch('components/getPageConfig', {
          page_id: page_id
        });
      } else {
        this.$store.dispatch('components/getPageConfig', {
          page_id: page_id
        });
      }
    },
    // 退出编辑
    onEdit: function onEdit() {
      var _this = this;
      var flag = this.checkData();
      var tips = '';
      if (flag) {
        tips = '即将退出编辑，是否继续？';
      } else {
        tips = '即将退出编辑，还有编辑数据未保存，将会丢失，是否继续？';
      }
      this.$confirm("".concat(tips), '提示', {
        confirmButtonText: '继续离开',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$router.go(-1);
      }).catch(function () {});
    },
    // 预览
    handleCommand: function handleCommand(command) {
      window.open(command, '_blank');
    },
    // 对比数据
    checkData: function checkData() {
      var page_init_data = this.page_init_data,
        cur_select_module = this.cur_select_module;
      var page_component = page_init_data.page_component;
      // 把当前页面的配置数据过滤掉无需对比的字段
      var newInit = JSON.stringify(page_component);
      var newCurrent = JSON.stringify(cur_select_module, function (k, v) {
        if (k === 'index') {
          return undefined;
        }
        return v;
      });
      // newCurrent = JSON.parse(newCurrent);
      // _.isMatch数据删除无法对比
      // const isModiInfo = _.isMatch(page_component, newCurrent);
      return newInit === newCurrent;
    },
    /**
     * 保存 & 同步
     * 说明：必须先保存，才能同步 （页面展示始终是测服的数据）
     * @params environment 环境  {dev：保存、pro：同步}
     */
    onSave: function () {
      var _onSave = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(environment) {
        var type, page_id, page_init_data, cur_select_module, status, isModiInfo, params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type = this.type, page_id = this.page_id, page_init_data = this.page_init_data, cur_select_module = this.cur_select_module;
              status = page_init_data.status; // 数据变更检查
              isModiInfo = this.checkData();
              _context.prev = 3;
              _context.next = 6;
              return this.$refs.moduleConfig.validator();
            case 6:
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              this.$message({
                message: '填写的数据格式有误！',
                type: 'error'
              });
              return _context.abrupt("return");
            case 12:
              // if (environment == 'dev' && isModiInfo) {
              //     this.$message('数据无变更，无需保存');
              //     return;
              // }
              params = {
                page_id: page_id,
                app_id: page_init_data.app_id,
                flag: page_init_data.flag,
                page_component: cur_select_module
              };
              if (environment == 'dev') {
                // 保存测服
                this.saveDev(params, type);
              } else {
                // 同步线上
                if (status == 'dev') {
                  this.savePro(page_id);
                } else if (status == 'pro' && !isModiInfo) {
                  this.loading = false;
                  this.$message.error('请先保存到测服！');
                } else if (status == 'pro' && isModiInfo) {
                  this.loading = false;
                  this.$message.error('数据已同步！如果有修改无法同步，请先保存到测服！再同步');
                }
              }
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 8]]);
      }));
      function onSave(_x) {
        return _onSave.apply(this, arguments);
      }
      return onSave;
    }(),
    // 保存测服
    saveDev: function saveDev(params, type) {
      var _this2 = this;
      this.$confirm("\u662F\u5426\u4FDD\u5B58\u5230\u6D4B\u670D\uFF1F", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.loading = true;
        _this2.loadingText = '保存中，请不要操作或关闭当前页面，避免数据丢失...';
        (0, _yunying.savePageConfigDev)(JSON.stringify(params), type).then(function (_ref) {
          var data = _ref.data;
          _this2.loading = false;
          _this2.$message({
            message: '保存成功',
            type: 'success'
          });
          // 重置页面数据
          _this2.initConfigData();
        }).catch(function () {
          _this2.loading = false;
        });
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    // 保存线上
    savePro: function savePro(page_id) {
      var _this3 = this;
      this.$confirm("\u662F\u5426\u540C\u6B65\u5F53\u524D\u9875\u9762\u914D\u7F6E\u5230\u7EBF\u4E0A\uFF1F", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.loading = true;
        _this3.loadingText = '同步中...';
        (0, _yunying.savePageConfigPro)({
          page_id: page_id
        }).then(function (_ref2) {
          var data = _ref2.data;
          _this3.loading = false;
          _this3.$message({
            message: '已同步上线',
            type: 'success'
          });
          // 重置页面数据
          _this3.initConfigData();
        }).catch(function () {
          _this3.loading = false;
        });
      }).catch(function () {
        _this3.loading = false;
      });
    },
    switchChange: function switchChange(e) {
      this.switchFlag = e ? 'on' : 'off';
      _jsCookie.default.set('url_switch', e ? 'on' : 'off');
    }
  }
};